import { ValidationType } from '@/constants/validationTypes';
import { Validation } from '../../sceneDataSchema';
import { z } from 'zod';

export function booleanValidator(validations: Validation[]): z.ZodBoolean | z.ZodNullable<z.ZodBoolean> {
  if (validations.some(({ type }) => type == ValidationType.Required)) {
    return z.boolean({ message: 'this field is required' });
  }

  return z.boolean({ message: 'this field is required' }).nullable();
}
